<template>
  <van-dialog 
    class="w complaint-dialog--components"
    v-model="localShow" 
    title="投诉" 
    overlay
    :close-on-click-overlay='true'
    :before-close='handleClose'
    @confirm='handleSuccess'>
    <div class="title">请选择投诉原因：</div>
    <van-radio-group class="options-box" v-model="Reason">
      <van-radio class="options" v-for="res in list" :key="res" :name="res">{{res}}</van-radio>
    </van-radio-group>
  </van-dialog>
</template>
<script>
import {Cms} from '@/api'
export default {
  props: {
    ArticleId: {
      required: true,
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.localShow = val
    }
  },
  data() {
    return {
      Reason: '',
      localShow: this.value,
      list: [
        '内容低俗',
        '诽谤造谣',
        '标题夸张',
        '重复旧闻',
        '政治敏感',
        '侵权抄袭'
      ]
    };
  },
  methods: {
    handleSuccess() {
      if (this.Reason == '') {
        this.$tips.error('请选择投诉原因')
        return false
      }
      this.$api(Cms.Complain, {ArticleId: this.ArticleId, Reason: this.Reason})
      this.$tips.success('感谢您的建议，我们会尽快处理')
    },
    handleClose(action, done) {
      done()
      this.$emit('input', false)
    }
  }
};
</script>
<style lang='scss' scoped>
.complaint-dialog--components {
  padding-bottom: 10px;
  .title {
    font-size: $font-size-normal;
    line-height: 30px;
  }
  .options-box {
    margin-bottom: 20px;
  }
  .options {
    padding: 6px 0;
    font-size: 14px;
  }
}
</style>